import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 9999;

    touch-action: none;
`;

export const ModalContainer = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    width: 520px;
    max-width: 92vw;
    padding: 20px;

    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);

    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: #4b4b4b;
    cursor: pointer;
    padding: 4px;

    &:hover {
        color: #000;
    }
`;

export const SignatureWrapper = styled.div`
    position: relative; 
    border: 1px solid #555;
    border-radius: 8px;
    background-color: #ffffff;

    aspect-ratio: 2.8 / 1;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    touch-action: none;
    user-select: none;

    &::after {
        content: "";
        position: absolute;
        left: 3%;
        right: 3%;
        bottom: 25%;        
        height: 1px;
        background-color: rgba(0, 0, 0, 0.5);
        pointer-events: none; 
    }

    canvas {
        display: block;
    }
`;

export const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`;
